/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Agenda extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div id="agenda" className="section-5-et section -agenda --black block-4 z-20 mb-2">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-62 white-text bold-text text-uppercase">The<br/><span className="f-100 ls-5">DISRUPT WEEK</span><br/>Agenda</h1>
                            </div>
                        </div>

                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">STARTUP GRIND: Disrupt Bayamon<br/></h1>
                                        <h1 className="f-22 white-text text-normal  text-uppercase">
                                            Engine-4 Co-Working Space
                                            <br/>
                                            Complejo Onofre Carballeira Esq. PR-2 con Int. PR-5, Bayamón, 00959
                                            </h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">THURSDAY, OCTOBER 18
                                            @ 6PM</h1>
                                    </div>
                                </div>
                            </div>

                            <div className="row m0">
                                <div className="col s12 m12 left-align">


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">6PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Check-In
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Investing in Puerto Rico Fireside Chat
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">8PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Networking + Happy Hour sponsored by Rum of PR
                                            </p>
                                        </div>
                                    </div>



                                </div>
                            </div>


                        </div>



                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">HACKATHON: Disrupt Hato Rey<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">Hackea por una Causa @ BANCO POPULAR FOUNDATION<br/></h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">SATURDAY, October 20th - Sunday, October 21st</h1>
                                    </div>
                                </div>
                            </div>

                            <div className="row m0">
                                <div className="col s12 m12 left-align">


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">9AM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Hackathon Begins
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Introduction to Blockchain w/ Alex Dovzhanyn

                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Build your own Blockchain with Javascript w/ Alex Dovzhanyn

                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Introduction to Twilio
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Build your first Chat Bot w/ Nick Scott
                                            </p>
                                        </div>
                                    </div>





                                </div>
                            </div>
                        </div>



                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">POOL PARTY: Disrupt Isa Verde<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">Vivo Beach Club<br/>
                                            Calle Avenue Boca de Cangrejos, Carolina, 00983</h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">SATURDAY, October 20th</h1>
                                    </div>
                                </div>
                            </div>

                            <div className="row m0">
                                <div className="col s12 m12 left-align">


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Tropical Happy Hour
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">8PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Pool Party Begins
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Pool Party Ends
                                            </p>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>



                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">DAY 1: Disrupt Old San Juan<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">
                                            PILOTO 151 - Old San Juan
                                            <br/>
                                            151 Calle San Francisco, San Juan, 00901<br/></h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">Monday, October 22nd</h1>
                                    </div>
                                </div>
                            </div>





                            <div className="row m0">
                                <div className="col s12 m12 left-align">


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10AM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                               registration / REGISTRO
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11AM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                OPENING KEYNOTE / discurso de inicio
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">12PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Change to an Abundance State of Mind w/ Kelitza Brana
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Cambiar a un estado Mental de Abundancia /  Kelitza Brana
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                The Future of Money w/ JAYDEN SAGE
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                    <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                    <div className="col s9 left-align">
                                        <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                            EL FUTURO DEL DINERO / JAYDEN SAGE
                                        </p>
                                    </div>
                                </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Automated Day Trading w/ Sang Lucci
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                hacer dinero automatizado w/ Sang Lucci
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2:30PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                The Entrepreneur / Investor Relationship w/ Randy Thompson
                                            </p>
                                        </div>
                                    </div>








                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Big Data & Blockchain w/ STEPHEN LUPSHA
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                DATOS GRANDES Y Blockchain / STEPHEN LUPSHA
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Blockchain in Puerto Rico w/ Mario "Billion" Salazar, CEO of Blockfinity
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">5PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Keynote w/ RHETT CREIGHTON
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                discurso / RHETT CREIGHTON
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">6PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                VALHALLA Private Capital Social Event
                                            </p>
                                        </div>
                                    </div>





                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">CRYPTO MONDAY @ The Poet's Passage</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">CRYPTO LUNES @ The Poet's Passage</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 m3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10PM</p></div>
                                        <div className="col s9 m9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">HAPPY HOUR @ LA FACTORIA</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">DAY 2: Disrupt Cupey<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">Science, Technology & Research Trust
                                            <br/>Antigua Penitenciaria Estatal Carr. # 21, Bo. Monacillos, 00927</h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">Tuesday, October 23rd</h1>
                                    </div>
                                </div>
                            </div>

                            <div className="row m0">
                                <div className="col s12 m12 left-align">


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                OPENING KEYNOTE / discurso de inicio
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1:30PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Zero to $5K Per month with Zero Experience w/ Alex Grieco
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Cero a $ 5K por mes con experiencia Cero / Alex Grieco
                                            </p>
                                        </div>
                                    </div>







                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Influencing with Storytelling w/ Kirill Sopot
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"> </p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Influencia con la narración de cuentos w/ Kirill Sopot
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2:30PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Fireside Chat w/ George Ohan
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                How to Launch an Agency in 7 Days w/ LAURA EGOCHEAGA
                                            </p>
                                        </div>
                                    </div> <div className="row mb0 grey-border-bottom p-20-all">
                                    <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"> </p></div>
                                    <div className="col s9 left-align">
                                        <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                            Cómo lanzar una agencia en 7 días / LAURA EGOCHEAGA
                                        </p>
                                    </div>
                                </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"> </p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Diaspora Puerto Rico w/ Pedro Rivera
                                            </p>
                                        </div>
                                    </div>




                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                HOW TO SCALE AN AI STARTUP THAT IS READY FOR Y-Combinator w/ BrainHi
                                            </p>
                                        </div>
                                    </div>




                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                CÓMO hacer que su empresa esté lista para Silicon Valley w/ BrainHi
                                            </p>
                                        </div>
                                    </div>









                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">5PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Diaspora in Puerto Rico: Nuyorican Movement
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7pm</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">NETWORKING HAPPY HOUR @ TRESBE
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>



                        </div>

                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">DAY 3: Disrupt SANTURCE<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">Parallel 18 <br/>
                                            1250 Avenida Juan Ponce de León, San Juan, 00907</h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">Wednesday, October 24th</h1>
                                    </div>
                                </div>



                                <div className="row m0">
                                    <div className="col s12 m12 left-align">

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">12PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    Lunch and Learn sponsored by Parallel 18
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    STARTUPS IN PUERTO RICO - WORK HARD. PLAY TROPICAL.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    EMPRESAS EN PUERTO RICO - TRABAJO DURO. JUEGA TROPICAL.
                                                </p>
                                            </div>
                                        </div>






                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    Direct to Consumer Marketing w/ Kaivan Dave
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2:30PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    Artificial Intelligence and the Internet of Things w/ Josè M de Abongüez
                                                </p>
                                            </div>
                                        </div>


                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    The Best Route For Startups: Integrating Africa & Empathy w/ Felix Ekwueme
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    MESSAGE FROM Jason Feifer - Entrepreneur Magazine
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4:30PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    7 Figure Lead Generation w/ Paul Faerstein
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">5PM</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    Access to Venture Capital in Puerto Rico w/ Allison Kern
                                                </p>
                                            </div>
                                        </div>


                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7pm</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">NETWORKING HAPPY HOUR @ DELAVIDA
                                                </p>
                                            </div>
                                        </div>


                                        <div className="row mb0 grey-border-bottom p-20-all">
                                            <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">8pm</p></div>
                                            <div className="col s9 left-align">
                                                <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                    AFTER PARTY @ HARDROCK CAFE
                                                </p>
                                            </div>
                                        </div>








                                    </div>
                                </div>

                            </div>



                        </div>

                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">DAY 4: Disrupt Puerto Rico <br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">
                                            PILOTO 151 - Old San Juan
                                            <br/>
                                            151 Calle San Francisco, San Juan, 00901<br/></h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">Thursday, October 25th</h1>
                                    </div>
                                </div>
                            </div>






                            <div className="row m0">
                                <div className="col s12 m12 left-align">

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11AM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                OPENING KEYNOTE
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11:30AM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                STARTUP PITCH COMPETITION
                                            </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">12PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                LUNCH / NETWORKING
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1PM</p>
                                        </div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                KEYNOTE - JENNIFER HOPP
                                            </p>
                                        </div>
                                    </div>



                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1:30PM</p>
                                        </div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                KEYNOTE - GERARD ADAMS
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">

                                                The Failure of Success w/ Dr Mark Wade


                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2:30PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                BUILD YOUR EMPIRE w/ JOHN MALOTT
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3:30PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                KEYNOTE - Paul Faerstein
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Start a Podcast to 10X your Network w/ Travis Chappell
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4:30PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                Future of Voice and AI / Tom La Veccia
                                            </p>
                                        </div>
                                    </div>

                                    <div className="hide row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7:10PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                KEYNOTE - OMAR PRESTWICH / K-SWISS
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">5PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                How we got into Y-Combinator - Emmanuel Oquendo
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">6PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                KEYNOTE - Denisse Rodríguez / Colmena66
                                            </p>
                                        </div>
                                    </div>








                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                FCKUP NIGHTS - DISRUPT Edition: Embracing Failure to Obtain Success
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10pm</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                DISRUPT AFTER PARTY @ SECRET LOCATION
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10:30pm</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                DISRUPT AWARDS
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>





                        </div>

                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">Day 5: POOL PARTY<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">VIP MASTERMIND & Pool Party @ Vivo Beach Club<br/></h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">FRIDAY, October 26th @ 7PM</h1>

                                    </div>
                                </div>
                            </div>

                            <div className="row m0">
                                <div className="col s12 m12 left-align">
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                VIP MASTERMIND @ Vivo Beach Club
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4PM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                PRIVATE VIP LUNCH @ Vivo Beach Club
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7pm</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">POOL PARTY @ Vivo Beach Club
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>



                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-gradient">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 black-text bold-text text-uppercase mb0">BONUS DAY:<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">Work Hard. Play Tropical.<br/></h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">Saturday, October 27th</h1>
                                    </div>
                                </div>
                            </div>



                            <div className="row m0">
                                <div className="col s12 m12 left-align">
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10:30AM</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                BURN x BRUNCH Workout w/ Paula Landron @ Punto Verde Al Fresco
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text"></p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">
                                                An event that combines FREE workouts with delicious -not included- brunch meals & unlimited mimosas
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3pm</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Tropical Happy Hour @                                     Eter Rooftop & Lounge </p>
                                        </div>
                                    </div>


                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">8pm</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">After After Party @ MIST Rooftop</p>
                                        </div>
                                    </div>



                                </div>
                            </div>

                        </div>





                        <br/>
                    </div>
                </div>
            </div>
        )

    }

}

export default Agenda;


// WEBPACK FOOTER //
// ./src/components/agenda.js